// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f531824c","455":"48e247c8","977":"15bcea94"}[chunkId] + ".chunk.js";
};